<template>
    <form class="page-filter-form">        
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Ministerio</label>
                    <ministry-select v-model="data[0].ministry_id" :ministries="this.ministries"></ministry-select>
                    <input type="hidden" name="ministry_id" :value="data[0].ministry_id" />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Institución</label>
                    <institution-select v-model="data[0].institution_id" :filter="[data.ministry_id]" :institutions="this.institutions"></institution-select>
                    <input type="hidden" name="institution_id" :value="data[0].institution_id" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Tipo Documento</label>
                    <page-type-select v-model="data[0].type"></page-type-select>
                    <input type="hidden" name="type" :value="data[0].type" />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Estado</label>
                    <status-select v-model="data[0].status"></status-select>
                    <input type="hidden" name="status" :value="data[0].status" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Publicado</label>
                    <published-select v-model="data[0].published"></published-select>
                    <input type="hidden" name="published" :value="data[0].published" />
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Comunicación</label>
                    <communication-select v-model="data[0].communication"></communication-select>
                    <input type="hidden" name="communication" :value="data[0].communication" />
                </div>
            </div>
        </div>
        <div class="row" v-if="this.admin">
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label">Recordatorios</label>
                    <reminder-select v-model="data[0].reminders"></reminder-select>
                    <input type="hidden" name="reminders" :value="data[0].reminders" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="control-label">Búsqueda</label>
            <input type="text" class="form-control" v-model="data[0].query" name="query" placeholder="Ej: certificado de nacimiento" />
        </div>        
        <div class="text-right">            
            <button type="submit" class="btn btn-primary">Filtrar</button>
        </div>
        
    </form>
</template>
<style lang="scss">

    .page-filter-form {
        .el-select {
            display: block;
        }
    }

</style>
<script>
    import MinistrySelect from './MinistrySelect.vue';
    import InstitutionSelect from './InstitutionSelect.vue';
    import StatusSelect from './StatusSelect';
    import CommunicationSelect from './CommunicationSelect';
    import PublishedSelect from './PublishedSelect';
    import PageTypeSelect from './PageTypeSelect';
    import ReminderSelect from './ReminderSelect';

    export default{
        data: function () {
            const data = {
                query: '',
                ministry_id: null,
                institution_id: null,
                status: null,
                communication: null,
                published: null,
                type: null,
                isHidden: true,
                ministries: null,
                institutions: null,
                reminders: null
            };

            return {
                data: _.assign(data, [this.filters, this.ministries, this.institutions])
            }
        },
        props: ['filters','ministries','institutions', 'admin'],
        components: {
            PageTypeSelect,
            PublishedSelect,
            MinistrySelect,
            InstitutionSelect,
            StatusSelect,
            CommunicationSelect,
            ReminderSelect
        }
    }
</script>